module.exports = __webpack_public_path__ + "static/media/tool.8e2878ff.png";